import { render } from "./RestoreComponent.vue?vue&type=template&id=3bef774e"
import script from "./RestoreComponent.vue?vue&type=script&lang=js"
export * from "./RestoreComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\WEB-APPS\\gizkia\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__